module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "nav",
    class: {
      'fixed': _vm.fixed
    }
  }, [_c('ul', _vm._l((_vm.navs), function(nav) {
    return _c('li', {
      class: {
        active: (_vm.activeNav === nav.ref)
      },
      attrs: {
        "data-ref": nav.ref
      },
      on: {
        "click": _vm.onClickNav
      }
    }, [_vm._v(_vm._s(nav.name))])
  }))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2de18c19"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductNav.vue
// module id = 636
// module chunks = 1